import * as React from 'react'
import { TextFieldProps } from 'cs-kevlar-react/lib/es/TextField'
import { JsonInput } from '../JsonInput'
import {
  InterfaceRegistration as InterfaceRegistrationDto,
  InterfaceFeatureFlag,
} from '../../api'
import { getInterfaceFeatureLabel } from 'utils'

type InterfaceRegistrationProps = TextFieldProps & {
  registration: InterfaceRegistrationDto | null
}

const inputProps = {
  readOnly: true,
}

export const InterfaceRegistration: React.FunctionComponent<InterfaceRegistrationProps> = ({
  registration,
  ...rest
}) => {
  let safeRegistration: Partial<InterfaceRegistrationDto> = registration
    ? registration
    : {}

  let featureFlags = []

  // convert enums to labels, FeatureFlags, EnabledFeatures
  if (safeRegistration.featureFlags) {
    const isNone = safeRegistration.featureFlags & InterfaceFeatureFlag.None
    const isGA =
      safeRegistration.featureFlags & InterfaceFeatureFlag.GeneralAvailability
    const canAddNarrative =
      safeRegistration.featureFlags & InterfaceFeatureFlag.AddNarrativeToCfs
    const canStatus =
      safeRegistration.featureFlags & InterfaceFeatureFlag.Statusing
    const canAssign =
      safeRegistration.featureFlags &
      InterfaceFeatureFlag.UserAssignToEmergencyResource

    if (isNone) featureFlags.push('None')
    if (isGA) featureFlags.push('GeneralAvailability')
    if (canAddNarrative) featureFlags.push('AddNarrativeToCfs')
    if (canStatus) featureFlags.push('Statusing')
    if (canAssign) featureFlags.push('UserAssignToEmergencyResource')
  }

  if (featureFlags.length === 0) {
    featureFlags.push('None')
  }

  return (
    <JsonInput
      json={{
        ...safeRegistration,
        enabledFeatures:
          safeRegistration.enabledFeatures?.map(enabledFeature =>
            getInterfaceFeatureLabel(enabledFeature),
          ) ?? [],
        featureFlags: featureFlags.join(', '),
      }}
      label="Interface Registration"
      rows={5}
      inputProps={inputProps}
      {...rest}
    />
  )
}
